import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MultiDomainMgmtService } from 'src/app/services/multi-domain-mgmt.service';
import { environment } from '../../../environments/local/environment';

@Component({
  selector: 'app-no-app-permission',
  templateUrl: './no-app-access.component.html',
  styleUrls: ['./no-app-access.component.scss'],
  standalone: false
})
export class NoAppAccessComponent implements OnInit, OnDestroy {
  description = '';
  private subscriptions = new Subscription();

  constructor(private multiDomainMgmtService: MultiDomainMgmtService, private translateService: TranslateService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.multiDomainMgmtService.getSharedMultiDomainProfile(true).subscribe({
        next: profile => {
          if (profile) {
            const activeDomain = profile.domains.find(d => d.active);

            if (activeDomain) {
              this.description = this.translateService.instant('OAUTH.NO_ACCESS.DESCRIPTION', {
                companyName: activeDomain.companyName
              });
            }
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  goToMHP() {
    window.open(environment.links.applications.hcp, '_self');
  }
}
